import Vue from 'vue'
import Router from 'vue-router'
import Splash from './pages/Splash'
import db from './database'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'splash',
      component: Splash
    },
    {
      path: '/collections/:collectionId',
      name: 'collection',
      component: () => import('@/pages/Collection'),
      props: true,
      beforeEnter (to, from, next) {
        if (!db.hasCollection(to.params.collectionId)) {
          next({ name: 'page-not-found' })
        } else {
          next()
        }
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/pages/Contact')
    },
    {
      path: '/page-not-found',
      name: 'page-not-found',
      component: () => import('@/pages/PageNotFound')
    },
    {
      path: '/:categoryId',
      name: 'category',
      component: () => import('@/pages/Category'),
      props: true,
      beforeEnter (to, from, next) {
        if (!db.hasCategory(to.params.categoryId)) {
          next({ name: 'page-not-found' })
        } else {
          next()
        }
      }
    }
  ]
})
